import rMinimalLogo from './Images/Logo RM.png';
import rMinimalHightlight from './Images/RM Cover.png'


export const ProjectApps = [
    {
        name: "Reddit Minimal",
        img: rMinimalLogo,
        img_aria: "Reddit Minimal",
        desc: "A fun project to learning basic REST API calls. Explore Reddit by searching subreddits and reading comments!",
        highlightImg: rMinimalHightlight,
        highlightImg_aria: "Landing page for reddit minimal",
        link: "https://arijai.github.io/reddit-minimal/",
    },
    {
        name: "COMING SOON",
        img: "",
        img_aria: "New projects coming soon",
        desc: "I'm always finding new things to do!",
        highlightImg: "",
        highlightImg_aria: "New projects coming soon",
        link: "/",
    }
];
